export default __webpack_public_path__ + "static/media/RejectDisable.d660dd4b.svg";